import React, { useEffect, useState } from "react";
import { getTrendingTrps } from "../../Services/HomeServices";
import { getVideo } from "../../Services/Video";
import hart_icon from "../../Assets/svg/hart_icon.svg";
import icon from "../../Assets/svg/icon1.svg";
import line_image from "../../Assets/svg/line_image.svg";
import profile_image1 from "../../Assets/png/profile_image1.png";
import profile_image2 from "../../Assets/png/profile_image2.png";
import image1 from "../../Assets/png/globl_img.png";
import image2 from "../../Assets/png/chand_image.png";
import image3 from "../../Assets/png/image1.png";
import image4 from "../../Assets/png/globl_img1.png";
import hart1 from "../../Assets/png/hart1.png";
import halts_icon from "../../Assets/png/halts_icon.png";
import three_dots from "../../Assets/png/three_dots.png";
import loction_icon from "../../Assets/png/location_icon.png";
import { useNavigate, useParams } from "react-router-dom";
import { getUserStats } from "../../Services/User";
import { countryFlag, getImageURL, replaceSpaceWithHyphen } from "../../Services/Common/helper";
import ReactPlayer from "react-player";
import VideoPlayer from "../Modals/VideoPlayer/VideoPlayer";
const TavelDetailTab = () => {
  const [trandingTrips, setTrandingTrips] = useState([]);
  const [video, setVideo] = useState([]);
  const [activeTab, setActiveTab] = useState("Trips");
  const [countryTitles, setContryTitles] = useState([]);
  const [stats, setStats] = useState("");
    const [selectVideoLink, setSelectedVideoLink] = useState("");
  const [player, setPlayer] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const getTranding = async () => {
    const res = await getTrendingTrps(id);
    setTrandingTrips(res);
  };

  const getStats = async () => {
    const res = await getUserStats(id);
    setStats(res);
  };

  useEffect(() => {
    getTranding();
    getStats();
  }, []);

  const getVideos = async () => {
    const res = await getVideo(id);
    setVideo(res?.videos);
  };

  function getCountryTitles(countryArray) {
    return countryArray?.map((countryKey) => {
      const country = countryFlag.find((country) => country.key === countryKey);
      return country ? country.Title : "Country not found";
    });
  }

  const handleVideoCLick = (link) => {
    setSelectedVideoLink(link);
    setPlayer(true);
  };
  useEffect(() => {
    getVideos();
  }, []);

  const countryArray = stats?.countries_visited
    ?.split(",")
    ?.map((country) => country.trim());

  useEffect(() => {
    const title = getCountryTitles(countryArray);
    setContryTitles(title);
  }, [stats]);
  return (
    <div className="bg-white pb-5">
      <div className="custom_container ">
        <div className="row px-3 gap-2 justify-content-center">
          <button
            className={`but d-flex gap-2 align-items-center justify-content-center col-md-2 col-sm-4  ${
              activeTab === "Trips" ? "active" : ""
            }`}
            onClick={() => handleTabClick("Trips")}
          >
            <svg
              className={` ${activeTab === "Trips" ? "svgactive" : ""}`}
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11.6 7.76564V5.23975M11.6 7.76564L7.86 13.8596L7.09777 15.1016M11.6 7.76564L14.8522 13.0647L15.1321 13.5207L15.34 13.8596L16.1022 15.1016M11.6 5.23975V1.25049C11.6 1.11242 11.7119 1.00049 11.85 1.00049H18.1302C18.3552 1.00049 18.4657 1.27443 18.3037 1.43052L16.7369 2.94008C16.6348 3.03841 16.6348 3.20183 16.7369 3.30015L18.3037 4.80972C18.4657 4.96581 18.3552 5.23975 18.1302 5.23975H11.6ZM7.09777 15.1016L2.48369 22.6197C2.38145 22.7863 2.50131 23.0005 2.69676 23.0005H11.6H20.5032C20.6987 23.0005 20.8185 22.7863 20.7163 22.6197L19.6491 20.8809L16.1022 15.1016M7.09777 15.1016C7.09777 15.1016 8.46677 16.418 11.6 15.1016C14.4691 13.896 16.1022 15.1016 16.1022 15.1016M15.9073 11.1438L16.7573 9.59644C16.8492 9.42911 17.0872 9.4224 17.1884 9.58429L19.6491 13.5207L24.0109 20.4983C24.115 20.6649 23.9953 20.8809 23.7989 20.8809H21.9496"
                stroke="#31383B"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span
              className={`fs_16 fw-normal ff_opne color_gray2 ${
                activeTab === "Trips" ? "active-text" : ""
              }`}
            >
              Trips
            </span>
          </button>
          <button
            className={`but d-flex gap-2 align-items-center col-md-2 col-sm-4  justify-content-center ${
              activeTab === "Statistics" ? "active" : ""
            }`}
            onClick={() => handleTabClick("Statistics")}
          >
            <svg
              className={`svg ${activeTab === "Statistics" ? "svgactive" : ""}`}
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.7499 10.9166C12.6786 10.9166 12.6088 10.8963 12.5487 10.858C12.4886 10.8198 12.4406 10.7652 12.4104 10.7007C12.3802 10.6361 12.369 10.5643 12.3781 10.4937C12.3872 10.423 12.4163 10.3564 12.4619 10.3016L15.3025 6.88499C15.3666 6.81052 15.4575 6.76422 15.5554 6.75606C15.6534 6.74789 15.7506 6.77852 15.8262 6.84134C15.9019 6.90416 15.9498 6.99416 15.9597 7.09196C15.9696 7.18975 15.9407 7.28753 15.8792 7.36424L13.0382 10.7812C13.003 10.8235 12.9589 10.8576 12.9091 10.8809C12.8593 10.9042 12.8049 10.9167 12.7499 10.9166Z"
                fill="#31383B"
              />
              <path
                d="M16.5 6.375C16.7071 6.375 16.875 6.20711 16.875 6C16.875 5.79289 16.7071 5.625 16.5 5.625C16.2929 5.625 16.125 5.79289 16.125 6C16.125 6.20711 16.2929 6.375 16.5 6.375Z"
                fill="#31383B"
              />
              <path
                d="M18.375 4.5C18.8721 4.5006 19.3487 4.69833 19.7002 5.04983C20.0517 5.40133 20.2494 5.8779 20.25 6.375C20.25 6.47446 20.2895 6.56984 20.3598 6.64017C20.4302 6.71049 20.5255 6.75 20.625 6.75C20.7245 6.75 20.8198 6.71049 20.8902 6.64017C20.9605 6.56984 21 6.47446 21 6.375C20.9992 5.67905 20.7224 5.01183 20.2303 4.51972C19.7382 4.02761 19.0709 3.75079 18.375 3.75C18.2755 3.75 18.1802 3.78951 18.1098 3.85984C18.0395 3.93016 18 4.02554 18 4.125C18 4.22446 18.0395 4.31984 18.1098 4.39016C18.1802 4.46049 18.2755 4.5 18.375 4.5Z"
                fill="#31383B"
              />
              <path
                d="M22.2588 17.2901L23.2938 16.2551C23.4611 16.0883 23.5715 15.8731 23.6094 15.64C23.6473 15.4068 23.6107 15.1677 23.505 14.9565L23.0868 14.1206C23.0071 13.9612 22.8907 13.823 22.7471 13.7175C22.6035 13.6119 22.4369 13.5419 22.2609 13.5134C22.085 13.4848 21.9048 13.4984 21.7352 13.5532C21.5656 13.6079 21.4114 13.7021 21.2853 13.8281L21.0491 14.0644L19.5322 10.0211L21.0131 8.79114C22.4384 7.60938 23.3652 5.93317 23.6081 4.09764C23.6614 3.69764 23.6218 3.29073 23.4923 2.90852C23.3629 2.52631 23.147 2.1791 22.8616 1.89387C22.5761 1.60863 22.2287 1.39304 21.8464 1.26386C21.4641 1.13468 21.0572 1.09538 20.6572 1.14902C18.8228 1.39173 17.1475 2.31764 15.966 3.74177L14.7375 5.21852L10.6863 3.69977L10.9215 3.46464C11.0475 3.33859 11.1418 3.18437 11.1966 3.01471C11.2514 2.84505 11.2651 2.6648 11.2365 2.48883C11.2079 2.31285 11.1379 2.14618 11.0323 2.00255C10.9267 1.85893 10.7884 1.74247 10.629 1.66277L9.79383 1.24502C9.58273 1.13902 9.34357 1.10233 9.1104 1.14017C8.87724 1.17801 8.66195 1.28845 8.49521 1.45577L7.46021 2.49077L3.88158 1.14902C3.81413 1.12388 3.74089 1.11865 3.67055 1.13394C3.60022 1.14923 3.53575 1.1844 3.48483 1.23527L1.98483 2.73527C1.94601 2.77411 1.9162 2.821 1.8975 2.87263C1.87879 2.92426 1.87166 2.97937 1.87659 3.03406C1.88153 3.08875 1.89842 3.14169 1.92606 3.18914C1.95371 3.23658 1.99143 3.27738 2.03658 3.30864L11.1063 9.58614L6.84746 14.7086L3.88908 13.5266C3.82094 13.4995 3.74633 13.4928 3.67447 13.5076C3.60262 13.5224 3.53668 13.558 3.48483 13.6099L1.98483 15.1099C1.94684 15.1479 1.91746 15.1936 1.89868 15.2439C1.87989 15.2942 1.87214 15.348 1.87594 15.4016C1.87975 15.4552 1.89502 15.5073 1.92073 15.5545C1.94644 15.6017 1.98198 15.6428 2.02495 15.675L4.71296 17.6903C4.47762 18.1835 4.29159 18.6987 4.15758 19.2285C4.11619 19.3941 4.11299 19.5669 4.14823 19.7339C4.18347 19.9009 4.25622 20.0578 4.36098 20.1925C4.46575 20.3272 4.59978 20.4364 4.75295 20.5117C4.90611 20.587 5.0744 20.6266 5.24508 20.6273C5.33903 20.627 5.4326 20.6153 5.52371 20.5924C6.05292 20.4586 6.56766 20.2729 7.06046 20.0381L9.07496 22.725C9.10721 22.7681 9.14835 22.8037 9.19559 22.8294C9.24282 22.8552 9.29504 22.8705 9.34871 22.8743L9.37496 22.875C9.42427 22.8751 9.47311 22.8654 9.51867 22.8466C9.56424 22.8277 9.60562 22.8 9.64046 22.7651L11.1405 21.2651C11.1924 21.2133 11.2279 21.1473 11.2427 21.0755C11.2575 21.0036 11.2509 20.929 11.2237 20.8609L10.0425 17.9051L15.165 13.6493L21.4417 22.7138C21.473 22.7589 21.5138 22.7966 21.5612 22.8243C21.6086 22.8519 21.6615 22.8689 21.7162 22.8739C21.7275 22.875 21.7387 22.8754 21.75 22.8754C21.8494 22.8754 21.9448 22.8358 22.0151 22.7655L23.5151 21.2655C23.566 21.2146 23.6013 21.1502 23.6166 21.0798C23.6318 21.0095 23.6266 20.9362 23.6013 20.8688L22.2588 17.2901ZM21.8156 14.3584C21.8576 14.3164 21.909 14.285 21.9655 14.2668C22.022 14.2486 22.0821 14.244 22.1407 14.2535C22.1993 14.2631 22.2549 14.2864 22.3027 14.3216C22.3506 14.3567 22.3894 14.4028 22.416 14.4559L22.8341 15.2918C22.8694 15.3621 22.8817 15.4418 22.8691 15.5195C22.8565 15.5972 22.8197 15.6689 22.764 15.7245L21.9693 16.5188L21.3382 14.8358L21.8156 14.3584ZM9.02546 1.98602C9.08106 1.93031 9.1528 1.89355 9.23049 1.88096C9.30818 1.86837 9.38786 1.88059 9.45821 1.91589L10.2941 2.33402C10.3472 2.3606 10.3932 2.39941 10.4284 2.44726C10.4636 2.49511 10.4869 2.55064 10.4964 2.60926C10.5059 2.66789 10.5014 2.72793 10.4832 2.78446C10.4649 2.84098 10.4336 2.89237 10.3916 2.93439L9.91533 3.41064L8.23158 2.77952L9.02546 1.98602ZM2.83308 2.94752L3.84446 1.93614L14.2297 5.82939L11.5878 9.00714L2.83308 2.94752ZM2.8207 15.3345L3.84071 14.3149L6.34308 15.315L5.87021 15.8839C5.57118 16.2389 5.30249 16.6183 5.06696 17.0183L2.8207 15.3345ZM5.33996 19.8653C5.27717 19.8809 5.21142 19.88 5.14908 19.8627C5.08673 19.8454 5.02993 19.8123 4.98418 19.7665C4.93843 19.7208 4.9053 19.664 4.888 19.6016C4.8707 19.5393 4.86982 19.4735 4.88546 19.4108C5.16691 18.291 5.69977 17.25 6.44358 16.3669L6.44546 16.3646L16.5423 4.22102C17.6041 2.94145 19.1097 2.10978 20.7581 1.89227C20.8419 1.8809 20.9263 1.87513 21.0108 1.87502C21.2776 1.87578 21.5411 1.93343 21.7837 2.04412C22.0264 2.15481 22.2427 2.31599 22.4181 2.51691C22.5936 2.71783 22.7241 2.95386 22.8011 3.20924C22.8781 3.46463 22.8997 3.73349 22.8645 3.99789C22.6464 5.64664 21.8139 7.15227 20.5335 8.21364L8.38308 18.3086C7.50009 19.0519 6.45939 19.5842 5.33996 19.8653ZM10.4347 20.9096L9.41546 21.9293L7.73283 19.6845C8.13186 19.4497 8.51044 19.1817 8.86458 18.8835L9.43571 18.4088L10.4347 20.9096ZM21.8025 21.9173L15.7443 13.1681L18.9213 10.5285L22.8138 20.9055L21.8025 21.9173Z"
                fill="#31383B"
              />
            </svg>

            <span
              className={`fs_16 fw-normal ff_opne color_gray2 ${
                activeTab === "Statistics" ? "active-text" : ""
              }`}
            >
              Statistics
            </span>
          </button>
          <button
            className={`but d-flex gap-2 align-items-center col-md-2 col-sm-4  justify-content-center ${
              activeTab === "Videos" ? "active" : ""
            }`}
            onClick={() => handleTabClick("Videos")}
          >
            <svg
              className={` ${activeTab === "Videos" ? "svgactive" : ""}`}
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.75049 12V4.76619C5.75049 3.9889 6.59846 3.50878 7.26499 3.9087L19.3213 11.1425C19.9687 11.5309 19.9687 12.4691 19.3213 12.8575L7.26498 20.0913C6.59846 20.4912 5.75049 20.0111 5.75049 19.2338V12Z"
                stroke="#31383B"
                stroke-linecap="round"
              />
            </svg>

            <span
              className={`fs_16 fw-normal ff_opne color_gray2 ${
                activeTab === "Videos" ? "active-text" : ""
              }`}
            >
              Videos
            </span>
          </button>
          <button
            className={`but d-flex gap-2 align-items-center col-md-2 col-sm-4  justify-content-center ${
              activeTab === "AI Video" ? "active" : ""
            }`}
            onClick={() => handleTabClick("AI Video")}
          >
            <svg
              className={` ${activeTab === "AI Video" ? "svgactive" : ""}`}
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.7559 21.9995C16.0843 21.6223 18.2082 20.436 19.7593 18.6462C21.3105 16.8565 22.1909 14.5762 22.248 12.2009C22.3051 9.82558 21.5353 7.50505 20.072 5.64173C18.6087 3.77842 16.5443 2.48985 14.2368 1.99951M10.0534 2.00279C8.71165 2.29012 7.44203 2.84986 6.32204 3.64788M3.94556 6.02693C3.14634 7.1502 2.58266 8.42575 2.28889 9.77576M2.25098 13.9511C2.52017 15.3063 3.0606 16.592 3.83929 17.7298M6.37838 20.301C7.50375 21.0913 8.77713 21.6423 10.1208 21.9204M10.251 8.55463C10.251 8.13282 10.7411 7.90055 11.0676 8.16765L15.278 11.6125C15.5225 11.8126 15.5225 12.1864 15.278 12.3865L11.0676 15.8314C10.7411 16.0985 10.251 15.8662 10.251 15.4444V8.55463Z"
                stroke="#31383B"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <span
              className={`fs_16 fw-normal ff_opne color_gray2 ${
                activeTab === "AI Video" ? "active-text" : ""
              }`}
            >
              AI Video
            </span>
          </button>
        </div>
        <div>
          {activeTab === "Trips" && (
            <div>
              <div className="row mt-5">
                {trandingTrips?.map((obj, i) => (
                  <>
                    <div
                      className="col-lg-4 col-sm-6 mt-4"
                      onClick={() => {
                        navigate(`/stories/${obj._id}/${replaceSpaceWithHyphen(obj.user_name)}/${replaceSpaceWithHyphen(obj.title)}/`);
                      }}
                    >
                      <div key={i} className="profile_card">
                        <div className="position-relative">
                          <div className="tripimg1">
                            <img
                              src={
                                "https://storage.trotterit.com/images/trip/" +
                                obj.image
                              }
                              className="cardimg w-100"
                            />
                          </div>
                          <div className=" position-absolute content_position">
                            <h5 className=" fs_20 fw-semibold ff_opne text-white">
                              {obj.user_name}
                            </h5>
                            <p className=" fs_18 ff_opne text-white">
                              {obj.user_place}
                            </p>
                          </div>
                          <div className="position-absolute icon_position">
                            <div className="d-flex gap-2 align-items-center">
                              <img src={hart_icon} alt="hart_icon" />
                              <p className="mb-0 fs_16 fw-normal ff_opne text-white">
                                {obj.halt_count} Likes
                              </p>
                            </div>
                            <div className="d-flex gap-2 mt-2 align-items-center">
                              <img src={icon} alt="hart_icon" />
                              <p className="mb-0 fs_16 fw-normal ff_opne text-white">
                                {obj?.view_count}
                              </p>
                            </div>
                          </div>
                          <div className=" position-absolute line_absolute">
                            <img src={line_image} alt="line_image" />
                            <p className="mb-0 fs_18 fw-semibold mt-2 ff_opne text-white">
                              {obj?.halt_count} Footprints{" "}
                              {Math.round(obj?.total_distance)} Kms
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ))}
              </div>
            </div>
          )}
          {activeTab === "Statistics" && (
            <>
              <div className="row mt-5">
                <div className="col-md-6">
                  <div className="profile_card2 h-100 text-center">
                    <img
                      width={259}
                      src={profile_image1}
                      alt="profile_image1"
                    />
                    <h6 className=" fs_24 fw-semibold ff_opne mb-0">
                      {stats?.total_trip}
                    </h6>
                    <p className="mb-0 fs_16 fw-semibold mt-1 ff_opne">TRIPS</p>
                  </div>
                </div>
                <div className="col-md-6 mt-4 mt-md-0">
                  <div className="profile_card2 h-100 text-center">
                    <img
                      width={259}
                      src={profile_image2}
                      alt="profile_image1"
                    />
                    <h6 className=" fs_24 fw-semibold ff_opne mb-0">3</h6>
                    <p className="mb-0 fs_16 fw-semibold mt-1 ff_opne">
                      CONTINENT VISITED
                    </p>
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <div className="col-md-6">
                  <div className="profile_card2 py-5 py-md-0 d-flex flex-column justify-content-center h-100 text-center position-relative">
                    <h6 className=" fs_32 fw-semibold ff_opne mb-0 color_gray2">
                      {stats?.total_distance} KM
                    </h6>
                    <p className="mb-0 fs_16 fw-semibold mt-1 ff_opne color_gray2">
                      LEFT TO THE MOON
                    </p>
                    <img
                      className=" position-absolute start-0 top-0 h-100"
                      src={image1}
                      alt="image1"
                    />
                    <img
                      className=" position-absolute end-0 top-0 h-100"
                      src={image2}
                      alt="image2"
                    />
                  </div>
                </div>
                <div className="col-md-6 mt-4 mt-md-0">
                  <div className="profile_card2 d-flex align-items-center justify-content-center gap-3 h-100 text-center">
                    <img width={180} src={image3} alt="profile_image1" />
                    <div className="text-center">
                      <h6 className=" fs_24 fw-semibold ff_opne mb-0 color_gray1">
                        4215
                      </h6>
                      <p className="mb-0 fs_16 fw-semibold mt-1 ff_opne color_gray2">
                        CARBON FOOTPRINTS
                      </p>
                      <p className="mb-0 fs_16 fw-semibold mt-1 ff_opne color_gray3 mt-2">
                        PLANT 421 TREES TO MAKE<br></br> IT ZERO
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 mt-4">
                <div className="profile_card2 pb-5 position-relative h-100 text-center">
                  <h6 className=" fs_24 fw-semibold ff_opne mb-0 color_gray1">
                    4215
                  </h6>
                  <p className="mb-0 pb-5 mb-sm-5 mb-3 fs_16 fw-semibold mt-1 ff_opne color_gray2">
                    CARBON FOOTPRINTS
                  </p>
                  <img
                    className=" position-absolute bottom-0 globle_image"
                    width={213}
                    src={image4}
                    alt="profile_image1"
                  />
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-md-6 mt-4 mt-md-0">
                  <div className="profile_card2 d-flex align-items-center justify-content-center gap-3 h-100 text-center">
                    <div>
                      <div className="d-flex gap-3 align-items-center">
                        {countryTitles?.map((item, index) => {
                          return (
                            <>
                              <img
                                width={45}
                                src={`https://storage.trotterit.com/images/flags/${item}.png`}
                                alt="icon2"
                              />
                            </>
                          );
                        })}
                      </div>
                      <div className="text-center pt-5 mt-3">
                        <h5 className=" fs_18 fw-semibold ff_opne mb-0 color_gray1">
                          {countryArray?.length}
                        </h5>
                        <p className="mb-0 fs_16 fw-semibold ff_opne color_gray3 mt-2">
                          COUNTRIES VISITED
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 h-100 mt-4 mt-md-0">
                  <div className="row">
                    <div className="col-6">
                      <div className="profile_card2 py-5 my-1 h-100 text-center">
                        <img src={hart1} alt="hart1" />
                        <p className="mb-0 mt-1">Total Likes</p>
                        <h4 className="mb-0 mt-1">
                          {stats?.total_likes} Likes
                        </h4>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="profile_card2 py-5 my-1 h-100 text-center">
                        {" "}
                        <img src={halts_icon} alt="hart1" />
                        <p className="mb-0 mt-1">Total Steps</p>
                        <h4 className="mb-0 mt-1">
                          {stats?.total_halts} Halts
                        </h4>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {activeTab === "Videos" && (
            <div>
              <div className="d-flex justify-content-center justify-content-md-start flex-wrap mt-4">
                {video?.map((item, index) => {
                  return (
                    <>
                      <div
                        className="mt-4 p-4 cursor-pointer"
                        onClick={() => handleVideoCLick(item?.media)}
                      >
                        <div className="position-relative">
                          <ReactPlayer
                            url={
                              "https://storage.trotterit.com/videos/" +
                              item?.media
                            }
                            pip={true}
                            controls={false}
                            playing={false}
                            loop
                            muted={true}
                            playsinline={false}
                            className="video"
                          />
                          <div className="position-absolute dots_position">
                            <img src={three_dots} alt="three_dots" />
                          </div>
                          <div className="position-absolute justify-content-between w-100 d-flex align-items-end gap-2 videoloction_position">
                            <div className="d-flex align-items-end">
                              <img src={loction_icon} alt="loction_icon" />
                              <p className="mb-0 fs_16 fw-semibold text-white ff_opne color_gray3">
                                {item?.place}
                              </p>
                            </div>
                            <div className=" pe-5">
                              <img src={icon} alt="hart_icon" />
                              <p className="mb-0 ps-2 ms-1 fs_16 fw-semibold text-white ff_opne color_gray3">
                                {item?.view_count}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          )}
          {activeTab === "AI Video" && <div>Content for AI Video tab</div>}
        </div>
      </div>
      <VideoPlayer
        show={player}
        close={() => {
          setPlayer(false);
        }}
        VideoLink={selectVideoLink}
      />
    </div>
  );
};

export default TavelDetailTab;
